import { compact, map, range } from 'lodash';

function formatMinutesToAmPmTime(minutes) {
  let totalHours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  let amPm = 'am';
  if (totalHours >= 12) amPm = 'pm';
  if (totalHours === 0) totalHours = 12;
  else if (totalHours > 12) totalHours -= 12;
  const hoursStr = totalHours.toString().padStart(2, '0');
  const minsStr = mins.toString().padStart(2, '0');
  return `${hoursStr}:${minsStr} ${amPm}`;
}

function getEffectiveBefore(before, date) {
  if (before || !date) {
    return before;
  }

  const now = new Date();
  const isToday = date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  return isToday ? now.getHours() * 60 + now.getMinutes() : before;
}

export function timeOfDayOptions({
  before,
  increment = 15,
  date,
} = {}) {
  const effectiveBefore = getEffectiveBefore(before, date);
  const dayIncrements = Math.floor((24 * 60) / increment);

  return compact([
    {
      value: '0',
      label: formatMinutesToAmPmTime(0),
      disabled: effectiveBefore > 0,
    },
    ...map(range(dayIncrements), (t) => {
      if (t === 0 || t === 1440) return null;

      const time = t * increment;

      return {
        label: formatMinutesToAmPmTime(time),
        value: time.toString(),
        disabled: effectiveBefore ? time <= effectiveBefore : false,
      };
    }),
  ]);
}
